
import { AnyAction } from "redux"
import { NOTIFICATIONS_DATA_FAIL, NOTIFICATIONS_DATA_REQ, NOTIFICATIONS_DATA_SUCC } from "redux/actions/notifications/type"
import { PLANS_DATA_FAIL, PLANS_DATA_REQ, PLANS_DATA_SUCC, PLANS_HISTORY_DATA_FAIL, PLANS_HISTORY_DATA_REQ, PLANS_HISTORY_DATA_SUCC } from "redux/actions/user/Type"


interface State {
    loading?: boolean
    data?: any,
    error?: string,


}

const defaultState: State = {
    loading: false,
    data: [],


}








// export const PLANS_HISTORY_DATA_REQ = "PLANS_HISTORY_DATA_REQ"
// export const PLANS_HISTORY_DATA_SUCC = "PLANS_HISTORY_DATA_SUCC"
// export const PLANS_HISTORY_DATA_FAIL = "PLANS_HISTORY_DATA_FAIL"
 
 


export const getPlansHistoryReducer = (state: State = defaultState, action: AnyAction) => {
    switch (action.type) {
        case PLANS_HISTORY_DATA_REQ:

            return {
                loading: true,
                data: state.data
            }
        case PLANS_HISTORY_DATA_SUCC:

            return {
                loading: false,
                data: action.payload,

            }
        case PLANS_HISTORY_DATA_FAIL:
            return {
                loading: false,
                error: action.payload
            }


        default:
            return state;
    }
}